import mergeWith from 'lodash/mergeWith'
import { setState, completeStep } from '@/models/createWarehouseReceivingOrder/commonActions/index'

export const NEXT_TRANSITION_NAME = 'NEXT'
export const VALID_NEXT_TRANSITION_NAME = 'VALID_NEXT'
export const HISTORY_TRANSITION_NAME = 'HISTORY'
export const generateTransitionName = (name) => `EDIT_${name.split(/(?=[A-Z])/).map(w => w.toUpperCase()).join('_')}`

const merger = (obj, src) => ({ ...obj, ...src })

const historyEnabled = (history) => history === undefined || history === true

export const buildStateNode = (definition) => ({
  nextStepNode,
  previousStepsNodes,
  stepNumber
}, history) => {
  const previousTransitions = previousStepsNodes
    .reduce((acc, n) => {
      const name = n.editState || n.name
      // EDIT_<name> transition that is put on every steps root state node that has previous steps
      acc[generateTransitionName(n.name)] = { [name]: { actions: [setState(n.name)] } }
      return acc
    }, {})
  const states = historyEnabled(history) ? { hist: { history: 'deep' } } : {}
  const transitions = { on: { ...previousTransitions }, states }
  if (nextStepNode) {
    const nextTransitionName = nextStepNode.name
    const validNextTransitionName = nextStepNode.editState || nextTransitionName
    const actions = { actions: [setState(nextStepNode.name), completeStep(stepNumber)] }
    // NEXT transition that is put on every steps root state node
    transitions.on[NEXT_TRANSITION_NAME] = { [nextTransitionName]: actions }
    transitions.on[VALID_NEXT_TRANSITION_NAME] = { [validNextTransitionName]: actions }
    transitions.on[HISTORY_TRANSITION_NAME] = historyEnabled(history) ? { [nextStepNode.name + '.hist']: actions } : { [nextStepNode.name]: actions }
  }
  return mergeWith(definition, transitions, merger)
}
